export function isApplicationModule(object) {
    return Object.prototype.hasOwnProperty.call(object, 'route');
}
export function isApplicationModuleGroup(object) {
    return Object.prototype.hasOwnProperty.call(object, 'modules');
}
function applicationModuleRegistryError(message) {
    return new Error(`[Application Module Registry]: ${message}`);
}
function createApplicationModuleRegistry() {
    const groups = new Map();
    const orphanModules = new Map();
    const modules = new Map();
    function get(id) {
        const module = modules.get(id);
        if (!module) {
            throw applicationModuleRegistryError(`Module with id "${id}" not found.`);
        }
        return module;
    }
    function getGroup(id) {
        const group = groups.get(id);
        if (!group) {
            throw applicationModuleRegistryError(`Group with id "${id}" not found.`);
        }
        return group;
    }
    function getAll() {
        const groupsArray = Array.from(groups.values());
        const modulesArray = Array.from(modules.values());
        return [...groupsArray, ...modulesArray];
    }
    function getGroups() {
        return Array.from(groups.values());
    }
    function getModules() {
        return Array.from(modules.values());
    }
    function getOrphanModules() {
        return Array.from(orphanModules.values());
    }
    function register(module) {
        const { id } = module;
        if (orphanModules.has(id)) {
            throw applicationModuleRegistryError(`There's already a module registered with the id "${id}".`);
        }
        orphanModules.set(id, module);
        modules.set(id, module);
    }
    function registerGroup(group) {
        const { id } = group;
        if (groups.has(id)) {
            throw applicationModuleRegistryError(`There's already a group registered with the id "${id}".`);
        }
        groups.set(id, group);
        for (const module of group.modules) {
            modules.set(module.id, module);
        }
    }
    function setDisabledModule(id, disabled) {
        const module = modules.get(id);
        if (!module) {
            throw applicationModuleRegistryError(`Module with id "${id}" not found.`);
        }
        modules.set(module.id, {
            ...module,
            disabled,
        });
        const orphanModule = orphanModules.get(id);
        if (orphanModule) {
            orphanModules.set(orphanModule.id, {
                ...orphanModule,
                disabled,
            });
        }
    }
    function isDisabledModule(id) {
        const module = modules.get(id);
        if (!module) {
            throw applicationModuleRegistryError(`Module with id "${id}" not found.`);
        }
        return Boolean(module.disabled);
    }
    function setHiddenModule(id, hidden) {
        const module = modules.get(id);
        if (!module) {
            throw applicationModuleRegistryError(`Module with id "${id}" not found.`);
        }
        modules.set(module.id, {
            ...module,
            hidden,
        });
        const orphanModule = orphanModules.get(id);
        if (orphanModule) {
            orphanModules.set(orphanModule.id, {
                ...orphanModule,
                hidden,
            });
        }
    }
    function isHiddenModule(id) {
        const module = modules.get(id);
        if (!module) {
            throw applicationModuleRegistryError(`Module with id "${id}" not found.`);
        }
        return Boolean(module.hidden);
    }
    return {
        get,
        getAll,
        getGroup,
        getGroups,
        getModules,
        getOrphanModules,
        isDisabledModule,
        isHiddenModule,
        register,
        registerGroup,
        setDisabledModule,
        setHiddenModule,
    };
}
export const applicationModuleRegistry = createApplicationModuleRegistry();
//# sourceMappingURL=application-module-registry.js.map